const errorMap: Record<string, string> = {
    Unauthorized: 'common.backend-errors.unauthorized',
};

export default errorMap;
